<template>
    <v-stepper v-if="getStages" v-model="currentStage" alt-labels>
        <v-stepper-header :class="items.length == 1 ? 'd-flex justify-center' : ''">
          <template v-for="(item, index) in items">
                <v-stepper-step :step="item.number" :complete="item.icon != undefined" :complete-icon="item.icon" :color="getColor(item)" :key="'i' + index">{{item.text}}</v-stepper-step>
                <v-divider v-if="canDivider(index)" :key="'d' + index"></v-divider>
            </template>
        </v-stepper-header>
      </v-stepper>
</template>

<script>
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'

export default {
  name: 'dr-stepper-component',
  mixins: [mixin, inputMixin],
  data: () => ({
    currentStage: null,
    items: null
  }),
  computed: {
    getStages() {
      let stages = this.getDataSourceField(this.model.Stages)
      if (stages == null || stages == undefined) {
        return false
      }
      this.updateItems(stages)
      return true
    }
  },
  methods: {
    getSlicedItems(items) {
      let sliced = items.slice(0, 3)
      let counter = items.length - sliced.length
      let lastItem = { id: 'empty', number: '+' + counter, text: this.$t('vuetifyWidgets.dr-stepper.stages', { count: counter }), isCurrent: false }
      sliced.push(lastItem)
      return sliced
    },
    updateItems(items) {
      this.currentStage = items[0].number
      this.items = items.length > 4 ? this.getSlicedItems(items) : [...items]
    },
    canDivider(value) {
      return this.items.length - value != 1 ? true : false
    },
    getColor(item) {
      return item.color == undefined ? 'green' : item.color
    }
  }
}
</script>